import { Variant } from '@mui/material/styles/createTypography'
import { measureTextWidth } from '../utils'
import { e3dcThemeOptions } from '@e3dc-react/theme/e3dc/theme-options'

export const useTextMeasurements = (variant: Variant): ((text: string) => number) => {
  const theme = e3dcThemeOptions
  const typography = typeof theme.typography === 'function' ? {} : theme.typography
  const fontSize = typography?.[variant]?.fontSize || 'inherit'

  return (text: string) => measureTextWidth(text, fontSize)
}
